import "core-js/modules/es.string.trim.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "etq-palette"
  }, [_c('div', {
    staticClass: "etq-panel-heading"
  }, [_vm._m(0), _c('span', {
    staticClass: "badge badge-light-primary"
  }, [_vm._v(_vm._s(_vm.elements.length))])]), _c('section', {
    staticClass: "palette-section"
  }, [_vm._m(1), !_vm.elements.length ? _c('div', {
    staticClass: "etq-palette-empty compact"
  }, [_c('i', {
    staticClass: "far fa-square"
  }), _c('span', [_vm._v("A etiqueta ainda está vazia.")])]) : _vm._e(), _vm._l(_vm.orderedElements, function (element) {
    return _c('button', {
      key: element.id,
      staticClass: "current-element",
      class: {
        selected: _vm.selectedId === element.id
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.$emit('select', element.id);
        }
      }
    }, [_c('span', {
      staticClass: "item-icon"
    }, [_c('i', {
      class: _vm.elementIcon(element)
    })]), _c('span', {
      staticClass: "item-copy"
    }, [_c('strong', [_vm._v(_vm._s(_vm.elementLabel(element)))]), _c('small', [_vm._v(_vm._s(_vm.elementKind(element)))])]), _c('span', {
      staticClass: "element-status",
      class: _vm.elementStatus(element).className
    }, [_vm._v(" " + _vm._s(_vm.elementStatus(element).label) + " ")])]);
  })], 2), _c('section', {
    staticClass: "palette-section available-section"
  }, [_vm._m(2), _c('div', {
    staticClass: "preset-list"
  }, _vm._l(_vm.availablePresets, function (preset) {
    return _c('button', {
      key: preset.key,
      staticClass: "preset-item",
      class: {
        present: Boolean(_vm.existingElement(preset))
      },
      attrs: {
        "type": "button",
        "disabled": preset.disabled && !_vm.existingElement(preset)
      },
      on: {
        "click": function click($event) {
          return _vm.usePreset(preset);
        }
      }
    }, [_c('span', {
      staticClass: "item-icon"
    }, [_c('i', {
      class: preset.icon
    })]), _c('span', {
      staticClass: "item-copy"
    }, [_c('strong', [_vm._v(_vm._s(preset.label))]), _c('small', [_vm._v(_vm._s(preset.helper))])]), _vm.existingElement(preset) ? _c('span', {
      staticClass: "preset-action"
    }, [_vm._v(" Ajustar "), _c('i', {
      staticClass: "fas fa-crosshairs"
    })]) : preset.disabled ? _c('span', {
      staticClass: "preset-action disabled"
    }, [_vm._v(" Preencha em Exemplo ")]) : _c('span', {
      staticClass: "preset-action"
    }, [_vm._v(" Adicionar "), _c('i', {
      staticClass: "fas fa-plus"
    })])]);
  }), 0)]), _c('section', {
    staticClass: "palette-section fixed-section"
  }, [_c('button', {
    staticClass: "section-toggle fixed-toggle",
    attrs: {
      "type": "button",
      "aria-expanded": _vm.fixedOpen
    },
    on: {
      "click": function click($event) {
        _vm.fixedOpen = !_vm.fixedOpen;
      }
    }
  }, [_vm._m(3), _c('i', {
    class: _vm.fixedOpen ? 'fas fa-chevron-up' : 'fas fa-chevron-down'
  })]), _vm.fixedOpen ? _c('div', {
    staticClass: "fixed-content"
  }, [_c('div', {
    staticClass: "input-icon fixed-search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.fixedSearch,
      expression: "fixedSearch",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "search",
      "placeholder": "Buscar NCM, lote, validade, empresa...",
      "aria-label": "Buscar outras informações fixas"
    },
    domProps: {
      "value": _vm.fixedSearch
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.fixedSearch = $event.target.value.trim();
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  }), _vm._m(4)]), !_vm.groupedFixedFields.length ? _c('div', {
    staticClass: "etq-palette-empty"
  }, [_c('i', {
    staticClass: "flaticon2-search-1"
  }), _c('span', [_vm._v("Nenhuma informação encontrada.")])]) : _vm._e(), _vm._l(_vm.groupedFixedFields, function (group) {
    return _c('div', {
      key: group.category,
      staticClass: "fixed-group"
    }, [_c('div', {
      staticClass: "fixed-group-title"
    }, [_c('span', [_vm._v(_vm._s(group.category))]), _c('small', [_vm._v(_vm._s(group.items.length))])]), _vm._l(group.items, function (fieldItem) {
      return _c('button', {
        key: fieldItem.key,
        staticClass: "fixed-field",
        class: {
          present: Boolean(_vm.existingFixedElement(fieldItem))
        },
        attrs: {
          "type": "button"
        },
        on: {
          "click": function click($event) {
            return _vm.useFixedField(fieldItem);
          }
        }
      }, [_c('span', {
        staticClass: "item-icon"
      }, [_c('i', {
        class: _vm.fixedFieldIcon(fieldItem)
      })]), _c('span', {
        staticClass: "item-copy"
      }, [_c('strong', [_vm._v(_vm._s(fieldItem.label))]), _c('small', [_vm._v(_vm._s(_vm.fixedFieldSample(fieldItem)))])]), _c('span', {
        staticClass: "preset-action"
      }, [_vm.existingFixedElement(fieldItem) ? [_vm._v(" Ajustar "), _c('i', {
        staticClass: "fas fa-crosshairs"
      })] : [_vm._v(" Adicionar "), _c('i', {
        staticClass: "fas fa-plus"
      })]], 2)]);
    })], 2);
  })], 2) : _vm._e()]), _c('section', {
    staticClass: "palette-section support-section"
  }, [_c('button', {
    staticClass: "section-toggle support-toggle",
    attrs: {
      "type": "button",
      "aria-expanded": _vm.supportOpen
    },
    on: {
      "click": function click($event) {
        _vm.supportOpen = !_vm.supportOpen;
      }
    }
  }, [_vm._m(5), _c('i', {
    class: _vm.supportOpen ? 'fas fa-chevron-up' : 'fas fa-chevron-down'
  })]), _vm.supportOpen ? _c('div', {
    staticClass: "etq-quick-grid"
  }, [_c('button', {
    staticClass: "etq-quick",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('add', 'text');
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-font"
  }), _c('span', [_vm._v("Texto livre")])]), _c('button', {
    staticClass: "etq-quick",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('add', 'qrcode');
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-qrcode"
  }), _c('span', [_vm._v("QR Code")])]), _c('button', {
    staticClass: "etq-quick",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('add', 'line');
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-minus"
  }), _c('span', [_vm._v("Linha")])]), _c('button', {
    staticClass: "etq-quick",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('add', 'rectangle');
      }
    }
  }, [_c('i', {
    staticClass: "far fa-square"
  }), _c('span', [_vm._v("Caixa")])])]) : _vm._e()])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('span', {
    staticClass: "etq-panel-kicker"
  }, [_vm._v("Conteúdo")]), _c('h5', [_vm._v("O que vai na etiqueta")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "section-heading"
  }, [_c('div', [_c('strong', [_vm._v("Na etiqueta")]), _c('small', [_vm._v("Clique para localizar e ajustar.")])])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "section-heading"
  }, [_c('div', [_c('strong', [_vm._v("Disponível neste teste")]), _c('small', [_vm._v("Segue as opções ligadas na aba Exemplo.")])])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', [_c('strong', [_vm._v("Outras informações fixas")]), _c('small', [_vm._v("Depois de adicionadas, fazem parte deste modelo e não dependem das opções da impressão.")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', [_c('i', {
    staticClass: "flaticon2-search-1 text-muted"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', [_c('strong', [_vm._v("Apoio visual")]), _c('small', [_vm._v("Texto livre, QR Code, linha e caixa.")])]);
}];
export { render, staticRenderFns };